import { render } from "./DocumentSearchMask.vue?vue&type=template&id=36efc313&scoped=true&ts=true"
import script from "./DocumentSearchMask.vue?vue&type=script&lang=ts"
export * from "./DocumentSearchMask.vue?vue&type=script&lang=ts"

import "./DocumentSearchMask.vue?vue&type=style&index=0&id=36efc313&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36efc313"]])

export default __exports__